<template>
	<nav
		class="sidebar py-4"
		:class="{
			'sidebar-collapsed': sidebarCollapsed,
			'sidebar-open': !sidebarCollapsed,
			'sidebar--ops': IS_OPS,
		}"
	>
		<router-link :to="{ path: '/' }" class="sidebar__logo-container mt-1 mb-2">
			<LogoIcon v-if="sidebarCollapsed" />
			<LogoHorizontal v-else color="white" sub-color="white" :animated="true" />
		</router-link>
		<PageNavigation :is-showing-homepage="isShowingHomepage" />
		<button
			type="button"
			aria-label="toggle sidebar"
			class="sidebar__toggle-btn"
			@click="onToggleSidebar"
		>
			<span
				class="bx"
				:class="{
					'bx-chevron-left': !sidebarCollapsed,
					'bx-chevron-right': sidebarCollapsed,
				}"
			/>
		</button>
	</nav>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import PageNavigation from '@shared/components/PageNavigation.vue';
import LogoHorizontal from '@shared/components/LogoHorizontal.vue';
import LogoIcon from '@shared/components/LogoIcon.vue';

defineProps<{
	isShowingHomepage: boolean;
}>();

const IS_OPS = process.env.VUE_APP_TYPE === 'ops';
const sidebarCollapsed = ref(false);

const onToggleSidebar = () => {
	sidebarCollapsed.value = !sidebarCollapsed.value;
	if (sidebarCollapsed.value) {
		localStorage.setItem('sidebarCollapsed', `true`);
	} else {
		localStorage.removeItem('sidebarCollapsed');
	}
};

onMounted(() => {
	if (localStorage.getItem('sidebarCollapsed')) sidebarCollapsed.value = true;
});
</script>

<style lang="scss" scoped>
$gradient-default: linear-gradient(180deg, $color-secondary 0%, $color-primary 100%);
$sidebar-open-size: 13rem;
$sidebar-collapsed-size: 4.5rem;

.sidebar {
	position: sticky;
	height: 100vh;
	top: 0;
	background: $gradient-default;
	display: flex;
	flex-direction: column;
	width: $sidebar-open-size;
	transition: width 0.75s;
	font-size: 1rem;

	grid-area: nav-bar;

	&__logo-container {
		display: flex;
		justify-content: center;
	}

	.logo-horizontal {
		width: 70%;
	}

	&__footer-navigation {
		margin-top: auto;
	}

	&__toggle-btn {
		display: flex;
		justify-content: flex-end;
		font-size: 40px;
		color: $color-white;
		margin-top: auto;
		margin-right: $spacing-4;
	}

	&--ops {
		background: black !important;
	}
}

.sidebar-collapsed {
	width: $sidebar-collapsed-size;
}
</style>
